<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.461050625,0.9317646622657776C4.301050625,0.9317646622657776,0.931640625,4.301174662265778,0.931640625,8.461174662265778C0.931640625,12.621164662265777,4.301050625,15.990564662265777,8.461050625,15.990564662265777C12.621040625,15.990564662265777,15.990440625,12.621164662265777,15.990440625,8.461174662265778C15.990440625,4.301174662265778,12.621040625,0.9317646622657776,8.461050625,0.9317646622657776C8.461050625,0.9317646622657776,8.461050625,0.9317646622657776,8.461050625,0.9317646622657776ZM9.402230625,13.167064662265778C9.402230625,13.167064662265778,7.519880625,13.167064662265778,7.519880625,13.167064662265778C7.519880625,13.167064662265778,7.519880625,11.284664662265778,7.519880625,11.284664662265778C7.519880625,11.284664662265778,9.402230625,11.284664662265778,9.402230625,11.284664662265778C9.402230625,11.284664662265778,9.402230625,13.167064662265778,9.402230625,13.167064662265778C9.402230625,13.167064662265778,9.402230625,13.167064662265778,9.402230625,13.167064662265778ZM9.402230625,10.343534662265778C9.402230625,10.343534662265778,7.519880625,10.343534662265778,7.519880625,10.343534662265778C7.519880625,10.343534662265778,7.519880625,3.7552946622657775,7.519880625,3.7552946622657775C7.519880625,3.7552946622657775,9.402230625,3.7552946622657775,9.402230625,3.7552946622657775C9.402230625,3.7552946622657775,9.402230625,10.343534662265778,9.402230625,10.343534662265778C9.402230625,10.343534662265778,9.402230625,10.343534662265778,9.402230625,10.343534662265778Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Error',
} as DefineComponent
</script>
